import request from '@/utils/request'

/**
 * 文章提交接口
 * @param {*} data
 *
 */
export function essaySubmit1API(data) {
    return request({
        url: `feedbackWithUserId?title=${data.title}&userId=${data.userId}`,
        method: 'post',
        data: data.body,
        headers: {
            'Content-Type': 'application/json'
        },
    })
}

/**
 * 文章提交接口2
 * @param {*} data
 *
 */
export function essaySubmit2API(data) {
    return request({
        url: `feedbackWithUserIdv2?title=${data.title}&userId=${data.userId}`,
        method: 'post',
        data: data.body,
        headers: {
            'Content-Type': 'application/json'
        },
    })
}


// WEBPACK FOOTER //
// ./src/api/writing/index.js